import { MimeCategory } from '@common/enums';
import { RestoreToAnotherUser } from '@common/models/restore-to-another-user.model';

export interface DriveOdataItem {
  DriveId?: any;
  ForDomainId?: any;
  IconLink: string;
  Id: string;
  MimeCategory: MimeCategory;
  MimeTypeId: string;
  Name: string;
  ParentIdStr?: any;
  Path: string;
  ProviderId: string;
  Size: number;
  ThumbLink: string;
  TreeItemType?: string; // it has been deleted on BE
  Type: DriveItemType;
  UserId: string;
}

export interface Revision {
  FileName: string;
  Id: string;
  ModifyDate: string;
}

export interface RevisionWithRaw extends Revision {
  Raw: string;
}

export interface DriveItemDetails {
  Description: string;
  IsDriveItem: boolean;
  IconM: string;
  Path: string[];
  Revisions: Revision[];
}

export enum DriveItemType {
  Folder,
  File
}

export type ItemDriveItemDetails = { drive: DriveOdataItem; details: DriveItemDetails };

export interface RestoreDriveItems {
  AnotherUser?: RestoreToAnotherUser;
  DriveId: string;
  Ids: string[];
  Timeline?: string; // "2020-08-26T21:00:00.000Z";
  ToRestoreFolder: boolean;
}

export enum DriveODataOption {
  UserId = 'userId',
  ProviderId = 'providerId',
  TeamDrive = 'teamDrive',
  SearchQ = 'searchQ'
}
